// ============================================================
// Income Modal (Create & Edit Income)
// ============================================================

import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, MenuItem, FormControl, InputLabel, Select, CircularProgress } from '@mui/material';

export function IncomeModal({ open, onClose, onSubmit, loading, income, categories = [] }) {
  const [incomeDate, setIncomeDate] = useState(new Date().toISOString().split('T')[0]);
  const [categoryId, setCategoryId] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [receiptUrl, setReceiptUrl] = useState('');

  useEffect(() => {
    if (income) {
      setIncomeDate(income.income_date || new Date().toISOString().split('T')[0]);
      setCategoryId(income.category_id || (income.category?.id || ''));
      setAmount(income.amount ? String(income.amount) : '');
      setDescription(income.description || '');
      setReceiptUrl(income.receipt_url || '');
    } else {
      setIncomeDate(new Date().toISOString().split('T')[0]);
      setCategoryId(categories.length > 0 ? categories[0].id : '');
      setAmount('');
      setDescription('');
      setReceiptUrl('');
    }
  }, [income, categories, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      income_date: incomeDate,
      category_id: categoryId,
      amount: Number(amount),
      description: description.trim() || 'Income Record',
      receipt_url: receiptUrl.trim() || '',
    };
    onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle fontWeight={700}>
          {income ? 'Edit Income Record' : 'Create New Income'}
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2.5} sx={{ mt: 1 }}>
            <TextField
              label="Income Date *"
              type="date"
              fullWidth
              required
              value={incomeDate}
              onChange={(e) => setIncomeDate(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
            />

            <FormControl fullWidth required>
              <InputLabel>Category *</InputLabel>
              <Select
                value={categoryId}
                label="Category *"
                onChange={(e) => setCategoryId(e.target.value)}
              >
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.name} {!cat.is_active ? '(Inactive)' : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Amount (₹) *"
              type="number"
              fullWidth
              required
              inputProps={{ min: 0, step: 'any' }}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            <TextField
              label="Description / Purpose"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <TextField
              label="Receipt URL (Optional)"
              fullWidth
              placeholder="https://..."
              value={receiptUrl}
              onChange={(e) => setReceiptUrl(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={onClose} color="inherit" disabled={loading}>
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            disabled={loading || !categoryId || !amount}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ fontWeight: 600, px: 3 }}
          >
            {loading ? 'Saving...' : income ? 'Update Income' : 'Save Income'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
